const isClient = typeof window !== 'undefined';
const isLocal = isClient && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1' || window.location.hostname.startsWith('192.168.'));

export const API_URL = isLocal 
  ? 'http://localhost:4001' 
  : (import.meta.env.VITE_API_URL || 'http://localhost:4001');

